export const DEFAULT_EMBED_WIDTH = "100%"; // "1000px" | "100%"
export const DEFAULT_EMBED_FIT = "fitToPage"; // "fitToWidth" | "fitToPage"
export const DEFAULT_NAVBAR = false;
export const DEFAULT_BACKGROUND_COLOR = "#fff";
